var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    attrs: {
      "title": ((_vm.isEdit === true ? '编辑':'创建') + "供应商"),
      "visible": _vm.showDialog
    },
    on: {
      "update:visible": function($event) {
        _vm.showDialog = $event
      }
    }
  }, [_c('el-form', {
    key: _vm.formIndex,
    ref: "ruleForm",
    staticClass: "form-beauty",
    attrs: {
      "model": _vm.ruleForm,
      "rules": _vm.rules,
      "label-width": "120px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "跟进HR"
    }
  }, [_vm._v(_vm._s(_vm.$store.state.user.name))]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "公司简称",
      "prop": "companyAbbr"
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请选择公司简称"
    },
    model: {
      value: (_vm.ruleForm.companyAbbr),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "companyAbbr", $$v)
      },
      expression: "ruleForm.companyAbbr"
    }
  }, _vm._l((_vm.companyList), function(company, key) {
    return _c('el-option', {
      key: key,
      attrs: {
        "label": company.name,
        "value": company.code
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "公司全称",
      "prop": "companyFullName"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入公司全称",
      "maxlength": 100
    },
    model: {
      value: (_vm.ruleForm.companyFullName),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "companyFullName", $$v)
      },
      expression: "ruleForm.companyFullName"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "对接人姓名",
      "prop": "linkman"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入对接人姓名",
      "maxlength": 50
    },
    model: {
      value: (_vm.ruleForm.linkman),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "linkman", $$v)
      },
      expression: "ruleForm.linkman"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "对接人邮箱",
      "prop": "email"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入对接人邮箱",
      "maxlength": 50
    },
    model: {
      value: (_vm.ruleForm.email),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "email", $$v)
      },
      expression: "ruleForm.email"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "对接人电话",
      "prop": "tel"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入对接人电话",
      "maxlength": 20
    },
    model: {
      value: (_vm.ruleForm.tel),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "tel", $$v)
      },
      expression: "ruleForm.tel"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "备注"
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入备注",
      "type": "textarea",
      "maxlength": 500
    },
    model: {
      value: (_vm.ruleForm.remark),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm, "remark", $$v)
      },
      expression: "ruleForm.remark"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.submitForm('ruleForm', true)
      }
    }
  }, [_vm._v("完成")]), _vm._v(" "), (!_vm.isEdit) ? _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": function($event) {
        return _vm.submitForm('ruleForm', false)
      }
    }
  }, [_vm._v("保存并添加下一位")]) : _c('el-button', {
    on: {
      "click": function($event) {
        _vm.showDialog = false
      }
    }
  }, [_vm._v("取消")])], 1)], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-437757ea"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/supplier/editSupplierDialog.vue
// module id = null
// module chunks = 